import React from 'react';
import ReactDOM from 'react-dom';
import "./assets/fonts/fonts.css";
// Design system HOANGLE CF — thứ tự import quan trọng: tokens trước, components sau
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/utilities.css";
import "./styles/components.css";
import "./styles/widgets.css";
import App from './App';
import { ContextProvider } from "./Context/Context";
import { HelmetProvider } from 'react-helmet-async';

/* FontAwesome đã bị bỏ hẳn — icon giờ là SVG nội tuyến, xem
   src/components/Icon/Icon.jsx (kèm lý do đầy đủ ở đầu file đó).
   Trò `import()` sau 100ms từng đứng ở đây KHÔNG có tác dụng trên production:
   react-snap prerender bằng Chrome thật nên chunk CSS của FA vẫn bị nướng thành
   <link> chặn render trong <head> của mọi trang tĩnh. */

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <ContextProvider>
        <App />
      </ContextProvider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
